import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import ArrowLeftIcon from '@/assets/nav-arrow-left.svg?react';

const BackToComplianceCoverage = ({ to }: { to: string }) => (
  <StyledLink to={to}>
    <ArrowLeftIcon />
    <FormattedMessage
      id="backToComplianceCoverage"
      defaultMessage="Back to Compliance Coverage"
    />
  </StyledLink>
);

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  marginBottom: theme.spacing(2),
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.textGray,
  textDecoration: 'none',
}));

export default BackToComplianceCoverage;
